import { render, staticRenderFns } from "./CustomerCorporateOrdersPause.vue?vue&type=template&id=60800cc0&scoped=true"
import script from "./CustomerCorporateOrdersPause.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateOrdersPause.vue?vue&type=script&lang=js"
import style0 from "./CustomerCorporateOrdersPause.vue?vue&type=style&index=0&id=60800cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60800cc0",
  null
  
)

export default component.exports